export default __webpack_public_path__ + "media/images/ui-icons_888888_256x240-04c5090561696a306c2ab91ec264f2a8.png";